import React, { useState } from 'react';
import '../assets/css/toggleSwitch.css'; // Importez le fichier CSS

function ToggleSwitch({ initialValue = false, title, onToggle }) {
    const [isChecked, setIsChecked] = useState(initialValue);

    const handleToggle = () => {
        const newValue = !isChecked;
        setIsChecked(newValue);
        if (onToggle) {
            onToggle(newValue); // Appelle la fonction de callback si elle est fournie
        }
    };

    // Génère un ID unique pour associer l'input et le label (important pour l'accessibilité)
    const uniqueId = React.useId(); // useId est un hook disponible à partir de React 18

    return (
        <div className="toggle-switch-container">
            <label>{title}</label>
            <input
                type="checkbox"
                id={uniqueId}
                className="toggle-switch-checkbox"
                checked={isChecked}
                onChange={handleToggle}
            />
            <label
                htmlFor={uniqueId}
                className="toggle-switch-label"
            >
                {/* Le pseudo-élément ::after dans le CSS crée le "thumb" */}
            </label>
        </div>
    );
}

export default ToggleSwitch;